import React, { useMemo } from "react";
import { formatMoney } from "../../../../../features/utils/formatMoney";

function PricingSectionPending({ data }) {
  return (
    <div className="w-full border h-fit border-gray-200 rounded-xl overflow-hidden bg-white mt-4 p-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900">Void</h2>
      </div>

      {/* Content */}
      <div className="bg-primary1/5 p-4 text-sm text-gray-700 gap-2 flex flex-col">
        <div className="bg-[#D9A513]/15 w-full rounded-md h-9 flex items-center justify-center text-yellow-600 font-semibold text-sm">
          Under review by Admin
        </div>
        {/* <span className="text-xs text-center w-full">
          Void request under review by airline
        </span> */}
        <hr className="w-full border border-gray-300" />
      </div>
    </div>
  );
}

export default PricingSectionPending;
